import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SugarService } from '../../model/sugar.service';
import { UrlService } from '../../model/url.service';
import { UniversalRendererHelper } from '../../shared/platform/universal-renderer.helper';
import { Utils } from '../../shared/utils.class';
import { DropdownSortOptions } from './dropdown-sort-options';
import { AutoUnsubscribe } from '../../decorators/autounsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'app-dropdown-sort',
  templateUrl: './dropdown-sort.component.html',
})
export class DropdownSortComponent implements OnInit {

  public sortBy: any = {};
  public currentValue = '';

  public menuID: string;
  @Input() collection = '';
  @Input() title = '';
  @Input() options: DropdownSortOptions;
  @Input() menuVersion: 'collapse' | 'dropdown' = 'dropdown';
  @Output() eventChange = new EventEmitter<string>();
  @ViewChild('root') root: ElementRef;
  @ViewChild('menu') menu: ElementRef;
  @ViewChild('btn') btn: ElementRef;
  private closeTimeout: any = null;

  constructor(
    private _sugarService: SugarService,
    private _rendererHelper: UniversalRendererHelper,
    public urlService: UrlService,
  ) {
    this.menuID = Utils.randomString();
  }

  ngOnInit(): void {
    this.sortBy = this._sugarService.getAvailableSorting(this.collection);

    if (!this.options) {
      this.options = {};
    }
  }

  changeSorting(id: string): void {
    this.currentValue = id;
    this._sugarService.changeSorting(this.collection, id);
  }

  onMouseenterDropdown(): void {
    this.preventDropdownClose();

    if (!this.options.clickOpen) {
      if (!this._rendererHelper.hasClass(this.root, 'show')) {
        this._rendererHelper.trigger(this.btn, 'click');
      }
    }
  }

  onMouseleaveDropdown(): void {
    this.closeDropdownIn(1000);
  }

  onMouseoverDropdown(): void {
    if (this.closeTimeout) {
      this.preventDropdownClose();
      this.closeDropdownIn(2000);
    }
  }

  onClickDropdown(evt?: any): void {
    if (evt && evt.target.hasAttribute('data-dropdown-item')) {
      evt.stopPropagation();
    }

    this.closeDropdownIn(1500);
  }

  closeDropdownIn(time: number): void {
    const self = this;

    this.preventDropdownClose();
    this.closeTimeout = setTimeout(() => {
      self.closeDropdown();
    }, time || 1000);
  }

  preventDropdownClose(): void {
    clearTimeout(this.closeTimeout);
  }

  closeDropdown(): void {
    this.preventDropdownClose();

    this._rendererHelper.removeClass(this.root, 'show');
    this._rendererHelper.removeClass(this.menu, 'show');

    this._rendererHelper.trigger(this.btn, 'blur');
  }

  trackByFn(index, item): number {
    return item.id;
  }

}
